import {
    CREATE_ASSET,
    CREATE_CONSUMABLE,
    CREATE_GENERIC_ASSET,
    CREATE_GENERIC_CONSUMABLE,
    CREATE_MANUFACTURER,
    CREATE_MEASURE_UNIT,
    CREATE_RECEIVED_CONSUMABLE,
    CREATE_SUPPLIER,
    FETCH_CONFIG_ASSET,
    FETCH_CONFIG_CONSUMABLE,
    FETCH_DEPLOYED_ASSET,
    FETCH_IN_OUT_CONFIG,
    FETCH_PENDING_ASSET,
    FETCH_PENDING_CONSUMABLES,
    FETCH_RECEIVED_CONSUMABLES,
} from "constants/ActionTypes";

const INITIAL_STATE = {
  data: [],
  loading: false,
  resultList: [],
  deployedAssetList: [],
  pendingAssetList: [],
  pendingConsumablesList: [],
  receivedConsumablesList: [],
  configAssetList: [],
  configConsumableList: [],
  inOutConfigList: [],
  genericConsumable: null,
  genericAsset: null,
  manufacturer: null,
  supplier: null,
  measureUnit: null,
};

const ResultReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_ASSET: {
      let updatedList = state.pendingAssetList;
      updatedList = [action.payload, ...updatedList];

      return {
        ...state,
        pendingAssetList: updatedList,
      };
    }
    case CREATE_CONSUMABLE: {
      let updatedList = state.pendingConsumablesList;
      updatedList = [action.payload, ...updatedList];

      return {
        ...state,
        pendingConsumablesList: updatedList,
      };
    }
    case CREATE_RECEIVED_CONSUMABLE: {
      let updatedList = state.receivedConsumablesList;
      updatedList = [action.payload, ...updatedList];

      return {
        ...state,
        receivedConsumablesList: updatedList,
      };
    }
    case FETCH_DEPLOYED_ASSET: {
      return {
        ...state,
        deployedAssetList: action.payload,
      };
    }
    case FETCH_PENDING_ASSET: {
      return {
        ...state,
        pendingAssetList: action.payload,
      };
    }
    case FETCH_RECEIVED_CONSUMABLES: {
      return {
        ...state,
        receivedConsumablesList: action.payload,
      };
    }
    case FETCH_CONFIG_ASSET: {
      return {
        ...state,
        configAssetList: action.payload,
      };
    }
    case FETCH_CONFIG_CONSUMABLE: {
      return {
        ...state,
        configConsumableList: action.payload,
      };
    }
    case FETCH_PENDING_CONSUMABLES: {
      return {
        ...state,
        pendingConsumablesList: action.payload,
      };
    }
    case CREATE_GENERIC_ASSET: {
      return {
        ...state,
        genericAsset: action.payload,
      };
    }
    case CREATE_GENERIC_CONSUMABLE: {
      return {
        ...state,
        genericConsumable: action.payload,
      };
    }
    case CREATE_MANUFACTURER: {
      return {
        ...state,
        manufacturer: action.payload,
      };
    }
    case FETCH_IN_OUT_CONFIG: {
      return {
        ...state,
        inOutConfigList: action.payload,
      };
    }
    case CREATE_SUPPLIER: {
      return {
        ...state,
        supplier: action.payload,
      };
    }
    case CREATE_MEASURE_UNIT: {
      return {
        ...state,
        measureUnit: action.payload,
      };
    }
    default:
      return state;
  }
};

export default ResultReducer;
